module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("enzRX"))).then(() => parcelRequire('1iHdE'));